export default __webpack_public_path__ + "static/media/startup-hero-image-reup.986c6d74.png";